import { FC, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Collapse, Text } from '@blueprintjs/core'
import cn from 'classnames'
import { Trans } from 'client/components/Trans/Trans'
import Chevron from 'images/chevron.png'
import { ClientLocaleNS } from 'lib/constants/locales'
import { useClickOutside } from 'lib/hooks/useClickOutside'

type TProps = {
  index: number
  elementsCount: number
}

const FaqListItem: FC<TProps> = ({ elementsCount, index }) => {
  const ref = useRef<HTMLLIElement>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { t } = useTranslation(ClientLocaleNS.MainPage)
  const blockNumber = index + 1

  useClickOutside([ref], () => {
    if (isOpen) {
      setIsOpen(false)
    }
  })

  return (
    <li ref={ref} className="flex w-full flex-col border-solid border-border-primary [&:not(:last-child)]:border-b">
      <div
        className="flex w-full cursor-pointer items-center justify-between gap-8 py-12 text-text-white max-lg:gap-4 max-lg:py-8"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Text tagName="span" className="font-primary-medium---18pt max-lg:font-primary-medium---15pt">
          {t(`faq_block.text_blocks.${blockNumber}.title`)}
        </Text>
        <div className="">
          <img
            src={Chevron}
            className={cn('w-6 object-contain text-text-white transition-all', isOpen && 'rotate-180')}
          />
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <div className="flex w-full flex-col gap-2 pb-8">
          {Array(elementsCount)
            .fill(null)
            .map((_, textIndex) => {
              const textNumber = textIndex + 1

              return (
                <Text
                  tagName="p"
                  className="font-primary-regular---15pt w-full whitespace-pre-wrap text-text-gray max-lg:font-primary-regular---12pt"
                >
                  <Trans
                    i18nKey={`faq_block.text_blocks.${blockNumber}.texts.${textNumber}`}
                    ns={ClientLocaleNS.MainPage}
                  />
                </Text>
              )
            })}
        </div>
      </Collapse>
    </li>
  )
}

export { FaqListItem }
